import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import VideoEmbed from 'components/VideoEmbed';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';

interface Props extends SitecoreBlockProps {
	fields?: {
		youTubeLink?: Field<string>;
	};
}

export default function YouTubeVideo({ fields, params }: Props) {
	if (!fields?.youTubeLink?.value) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="YouTubeVideo"
				description="Requires a youtubeLink"
			/>
		);
	}
	return (
		<LayoutContainer
			id={params?.anchor}
			outerClassName={getEditorMargin(params)}
		>
			<div className="max-w-col-6">
				<VideoEmbed url={fields.youTubeLink.value} />
			</div>
		</LayoutContainer>
	);
}
YouTubeVideo.displayName = 'YouTubeVideo';
